const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
    meta: {
      title: "MarkMePresent - Innovative Attendance Management System",
      description: "MarkMePresent — attendance management with geographical verification.",
      canonical: "https://markmepresent.com/"
    }
  },
];

export default routes;
